module.exports = __webpack_public_path__ + "static/media/31.10e3e568.jpg";